module.exports = __webpack_public_path__ + "static/media/tekno.e47fb4fe.jpg";